import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Section } from "../layout/Section";
import { Badge } from "../ui/Badge";
import { PolaroidCarousel } from "../ui/PolaroidCarousel";
import { useProfile } from "../../features/profile/hooks/useProfile";
export const HeroSection = () => {
    const { data: personal, isLoading } = useProfile();
    const headlineRef = useRef(null);
    useEffect(() => {
        if (!headlineRef.current)
            return;
        const lines = headlineRef.current.querySelectorAll(".hero-line");
        lines.forEach((line, i) => {
            const el = line;
            el.style.opacity = "0";
            el.style.transform = "translateY(60px)";
            setTimeout(() => {
                el.style.transition = "opacity 0.8s ease, transform 0.8s ease";
                el.style.opacity = "1";
                el.style.transform = "translateY(0)";
            }, 300 + i * 150);
        });
    }, []);
    if (isLoading || !personal)
        return null;
    const displayName = personal.name;
    return (_jsxs(Section, { id: "hero", className: "min-h-screen flex items-center", children: [_jsx("div", { className: "w-full max-w-3xl overflow-hidden", children: _jsxs("div", { className: "space-y-8", children: [_jsx(Badge, { variant: "pulse", className: "text-xs", children: personal.availability }), _jsx("h1", { ref: headlineRef, className: "text-display-2xl font-serif text-text-primary leading-[0.9] tracking-tight break-words", children: displayName.split(" ").map((part, i, arr) => (_jsx("span", { className: `hero-line block ${i === arr.length - 1 ? "text-text-muted" : ""}`, children: part }, part))) }), _jsx(motion.p, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.6, delay: 0.8 }, className: "text-body-lg text-text-muted max-w-lg", children: personal.tagline })] }) }), _jsx("div", { className: "w-full mt-12 md:mt-16 overflow-hidden", style: { position: "relative", zIndex: 1 }, children: _jsx(PolaroidCarousel, {}) }), _jsx(motion.div, { animate: { y: [0, 10, 0] }, transition: { duration: 2, repeat: Infinity }, className: "absolute bottom-8 left-1/2 -translate-x-1/2 cursor-pointer", onClick: () => document
                    .querySelector("#about")
                    ?.scrollIntoView({ behavior: "smooth" }), children: _jsx("div", { className: "w-6 h-10 border border-text-muted rounded-full flex items-center justify-center", children: _jsx("div", { className: "w-1 h-2 bg-text-muted rounded-full" }) }) })] }));
};
//# sourceMappingURL=HeroSection.js.map